const ToggleView = ({ show, children }) => {
  if (!show) return null;
  return children;
};
export { ToggleView };
